import React, { useEffect } from "react";
import Container from "@material-ui/core/Container";
import CreateIcon from "@material-ui/icons/Create";
import * as Glob from "src/Globale";
import { _MainContent, _PageTitle, _PageWrapper } from "../layout";
import { _ExposureLimitAccordion, _PolicyBondAccordion } from "../components";

export const _NewBond: React.FC<Glob.IRouteGlobaleProps> = props => {
    useEffect(() => {
        if (!Glob.AzioneAbilitata("FideAffidamentoController", Glob.Scrittura)) {
            location.replace("/ErroreAccesso");
            return;
        }
    }, []);

    useEffect(() => {
        props.SetMenu({ ...Glob.GetMenu(), Main: "Affidamento", ID_MenuMain: 0, VariabiliMenu: {} });
    }, []);

    return (
        <_PageWrapper {...props}>
            <Container component="main" maxWidth="lg">
                <_PageTitle Icon={CreateIcon} Title="Nuovo" />
                <_MainContent WithPaper={false}>
                    <_ExposureLimitAccordion />
                    <_PolicyBondAccordion />
                </_MainContent>
            </Container>
        </_PageWrapper>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/pages/NewBond.tsx